import { motion } from "framer-motion";
import QuoteModal from "@/components/QuoteModal";
const showroomImg = "/images/site/wood-species-sample-wall-livonia-design-center.webp";

const differentiators = [
  {
    title: "Performance Specification",
    desc: "We navigate the science behind every choice. Solid versus engineered construction, finish chemistries, and HVAC compatibility. Your design vision is built on a foundation that won't fail.",
  },
  {
    title: "Comprehensive Millwork",
    desc: "From species stability and milling cuts like Rift and Quartered, to seamless integration between floors, walls, ceilings, and reclaimed beams. We think in whole-home architectural systems.",
  },
  {
    title: "Limitless Custom Manufacturing",
    desc: "If you can design it, we can mill it. We create bespoke color matches, custom inlays, and complex architectural patterns. All manufactured right here in Michigan.",
  },
  {
    title: "The Livonia Design Center",
    desc: "A screen can't capture the depth of a wire brushed texture or the warmth of a custom stain. Bring your clients to our showroom. Walk the planks, feel the finishes, and collaborate directly with our installers led by an NWFA Certified Installer.",
  },
];

const TradeSection = () => (
  <section className="bg-neutral-950 py-14 md:py-20 lg:py-24" id="trade">
    <div className="max-w-[1200px] mx-auto px-5 md:px-12 grid md:grid-cols-2 gap-10 md:gap-14 items-center">
      {/* Left  copy */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-[11px] font-semibold tracking-[.12em] uppercase text-primary mb-2">
          For Architects &amp; Interior Designers
        </p>
        <h2 className="font-display text-[clamp(26px,4.5vw,46px)] font-semibold text-primary-foreground leading-[1.1] mb-4">
          Your Technical Specification Partner for{" "}
          <em className="italic font-normal text-gold-200">Custom Wood.</em>
        </h2>
        <p className="text-[13px] md:text-[15px] font-light text-primary-foreground/[.48] leading-relaxed max-w-lg mb-4">
          You hold the creative vision. We provide the engineering to bring it to life. We serve as your dedicated product specifiers for custom hardwood, engineered planks, architectural walls, wood ceilings, and reclaimed beams.
        </p>
        <p className="text-[13px] md:text-[15px] font-light text-primary-foreground/[.48] leading-relaxed max-w-lg mb-7">
          Our role is simple: we collaborate with your design team to ensure every aesthetic choice performs flawlessly in the real world. The ultimate blank canvas without the technical liability.
        </p>

        {/* Differentiators */}
        <div className="space-y-4 mb-8">
          {differentiators.map((d) => (
            <div key={d.title} className="flex gap-3">
              <span className="mt-1.5 block h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
              <div>
                <div className="text-sm font-semibold text-primary-foreground mb-0.5">{d.title}</div>
                <div className="text-xs font-light text-primary-foreground/40 leading-relaxed">{d.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Dual CTA */}
        <div className="flex flex-col sm:flex-row gap-3">
          <QuoteModal
            trigger={
              <button className="bg-primary text-primary-foreground px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-gold-400 hover:-translate-y-px transition-all text-center">
                Schedule a Showroom Consultation →
              </button>
            }
          />
          <QuoteModal
            trigger={
              <button className="border border-primary-foreground/25 text-primary-foreground px-7 py-3.5 rounded-full text-sm font-medium hover:border-primary-foreground/60 transition-colors text-center">
                Apply for Trade Pricing →
              </button>
            }
          />
        </div>
      </motion.div>

      {/* Right  image */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.15 }}
        className="relative rounded-[20px] overflow-hidden aspect-[4/5] min-h-[360px]"
      >
        <img width={800} height={534} loading="lazy"
          src={showroomImg}
          alt="Wood species sample wall at the 1 Wood Floors Livonia Design Center"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/60 via-transparent to-neutral-950/20" />
      </motion.div>
    </div>
  </section>
);

export default TradeSection;
